import { render, staticRenderFns } from "./SectionFieldsTable.vue?vue&type=template&id=6c0d34d8"
import script from "./SectionFieldsTable.ts?vue&type=script&lang=ts&external"
export * from "./SectionFieldsTable.ts?vue&type=script&lang=ts&external"
import style0 from "./SectionFieldsTable.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports